export * from './dynamic-table.component';
export * from './dynamic-table.module';
